<template>
  <layout>
    <page-header :actions="actions" :header="$t('general.new_layout_pricing_periods')" />
    <div class="content">
      <AdminTable v-if="currentDivision" ref="table" admin-table v-bind="tableProps">
        <template #period_from="{ item }">
          {{ formatDate(item.period_from) }}
        </template>
        <template #period_to="{ item }">
          {{ formatDate(item.period_to) }}
        </template>
        <template #vehicles="{ item }">
          <ul class="vehicle-list">
            <li v-for="vehicle in item.vehicles" :key="vehicle.id">
              <template v-if="rateLabel(vehicle)">
                <span>{{ vehicle.name }}:</span>
                <strong>{{selectedCurrency.symbol}}&nbsp;{{ rateLabel(vehicle) }}</strong>
              </template>
            </li>
          </ul>
        </template>
      </AdminTable>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import PeriodPricingApi from './Api'

const base = 'period_pricing'

export default {
  name: 'PeriodPricingIndex',

  components: {
    AdminTable,
  },

  data() {
    return {
      tableProps: {
        base,
        apiBuilder: () =>
          new PeriodPricingApi().setParameter('division_id', this.currentDivision.id),
        sortBy: 'updated',
        sortDesc: true,
        perPage: 1000,
        columns: [
          { key: 'id', label: this.$t('general.id') },
          {
            key: 'period_from',
            label: this.$t('vehicles.attributes.pricing.period_from.label'),
          },
          {
            key: 'period_to',
            label: this.$t('vehicles.attributes.pricing.period_to.label'),
          },
          {
            key: 'vehicles',
            label: this.$t('vehicles.zone_to_zone_vehicles'),
            formatter: value =>
              value && value.length ? value.map(v => v.name).join(', ') : '—',
          },
        ],
        rowActions: () => {
          const actions = []
          if (this.$allows('vehicles.update') || this.$allows('vehicles.view')) {
            actions.push('edit')
          }
          if (this.$allows('vehicles.delete')) {
            actions.push('delete')
          }
          return actions
        },
        bulkActions: () => [],
      },
    }
  },

  computed: {
    actions() {
      if (!this.$allows('vehicles.create') || !this.currentDivision) {
        return []
      }
      return [
        {
          id: 'create',
          text: this.$t('general.add_new'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            this.$router.push({ name: `${base}.create` })
          },
        },
      ]
    },
    selectedCurrency() {
      return this.$root.$account.currency ?? this.$settings.base_currency
    },
  },

  watch: {
    currentDivision() {
      this.$refs.table && this.$refs.table.reset()
    },
  },

  methods: {
    formatDate(value) {
      if (!value) {
        return '—'
      }
      return this.$moment(value).format('YYYY-MM-DD HH:mm')
    },
    rateLabel(vehicle) {
      const v = vehicle?.pivot?.one_way ?? vehicle?.pivot?.pricing?.one_way
      if (v == null || v === '') {
        return ''
      }
      return v
    },
  },
}
</script>

<style scoped>
.vehicle-list {
  list-style: none;
  margin: 0;
  padding: 0;
  color: #787878;
  font-size: 0.775rem;
}
.vehicle-list li {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
}
.vehicle-list li strong {
  color: #555;
}
</style>
